import { render, staticRenderFns } from "./UiMap.vue?vue&type=template&id=053fb46a&scoped=true&"
import script from "./UiMap.vue?vue&type=script&lang=ts&"
export * from "./UiMap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053fb46a",
  null
  
)

export default component.exports